import { inject } from '@angular/core';
import { CanActivateFn, Params, RedirectFunction, Router, UrlTree } from '@angular/router';

/**
 * The single registration entry point (#943). Every other way into signup
 * forwards here.
 */
export const QUICK_REGISTER_PATH = '/register/quick';

/**
 * The quick-register URL with the visitor's whole query string, so UTMs, ad
 * click IDs, `coupon` / `promo` and anything else on the link survive the
 * redirect.
 *
 * @param queryParams Query parameters of the URL being redirected.
 * @returns The redirect target.
 */
export function quickRegisterUrlTree(queryParams: Params): UrlTree {
  return inject(Router).createUrlTree([QUICK_REGISTER_PATH], { queryParams });
}

/**
 * `redirectTo` for retired signup paths (`/signup`, `/sign-up`). A function
 * rather than a string, so the query string is kept.
 */
export const redirectToQuickRegister: RedirectFunction = ({ queryParams }) =>
  quickRegisterUrlTree(queryParams);

/**
 * Guard for `/register`. Sends a visitor to `/register/quick`, keeping the
 * query string. An invitee (`/register?inviteCode=…`, from the invite landing
 * page) stays on the email-and-password signup: quick signup asks for a new
 * company, and an invitee joins an existing one.
 */
export const quickRegisterRedirectGuard: CanActivateFn = (route) =>
  route.queryParamMap.has('inviteCode') ? true : quickRegisterUrlTree(route.queryParams);
